// import { TextFieldEntry, isTextFieldEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from "bpmn-js-properties-panel";
import { html } from "htm/preact";
import { modelercallActivity } from "lib/stores.js";

export default function (element) {
  return [
    {
      id: "subprocessURL",
      element,
      component: callActivity,
      isEdited: true,
    },
  ];
}

function callActivity(props) {
  const { element, id } = props;

  const modeling = useService("modeling");
  const translate = useService("translate");
  const debounce = useService("debounceInput");

  const getValue = () => {
    return element.businessObject.subprocessURL || "";
  };

  const setValue = (value) => {
    return modeling.updateProperties(element, {
      subprocessURL: value.target.value,
    });
  };

  const openSelectorModal = () => {
    modelercallActivity.set({ open: true, value: getValue(), id: element.id });
  };
  // var asdf = html`<input type='text' value='asdf'/>aaaaaa`
  // return htmlpreact`${asdf}`;
  //return html`<input type='text' id=${ id } class='bio-properties-panel-input' value=${getValue()} setValue=${setValue}/>`
  return [
    html`<input
      type="text"
      id="properties_panel_input_${element.id}"
      class="bio-properties-panel-input"
      style="display:inline-block; width:58%; height:32px"
      value=${getValue()}
      oninput=${setValue}
    />`,
    html`<button
      class="bx--btn bx--btn--sm bx--btn--sm bx--btn--tertiary"
      onClick=${openSelectorModal}
    >
      Change
    </button>`,
    html`<br /><a
        id="properties_panel_link_${element.id}"
        href="${getValue() ? "/app/pman/?idprocess=" + getValue() : ""}"
        >Open Subprocess</a
      >`,
  ];
  //   return <TextFieldEntry
  //     id={ id }
  //     element={ element }
  //     description={ translate('Link to the subprocess') }
  //     label={ translate('callActivity URL') }
  //     getValue={ getValue }
  //     setValue={ setValue }
  //     debounce={ debounce }
  //   />
}
